// extracted by mini-css-extract-plugin
export var ourpd = "ourproduct-module--ourpd--2svtH";
export var fontheader = "ourproduct-module--fontheader--1ITEZ";
export var fontp = "ourproduct-module--fontp--3QTOi";
export var rowpd = "ourproduct-module--rowpd--3Y-KY";
export var conproduct = "ourproduct-module--conproduct--z09el";
export var colproduct = "ourproduct-module--colproduct--1qRSS";
export var fontpp = "ourproduct-module--fontpp--17Gih";
export var headerproduct = "ourproduct-module--headerproduct--25kfy";